/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const prefix = 'role-filter';

export const addRoleFilterModalBreadcrumbTitle = `${prefix}.addRoleFilterModalBreadcrumbTitle`;

export const ENGLISH = {
    [addRoleFilterModalBreadcrumbTitle]: 'Label Filter',
};
